// eslint-disable-next-line no-restricted-syntax
import { Application } from 'pixi.js';

export function initializePixiInspector(app: Application) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
  (globalThis as any).__PIXI_APP__ = app;
}
